import { mapGetters } from 'vuex'

import {
  AGENT_CONTAINER_INFO_REQ,
  CONTAINERINFO_BY_AGENTID_REQ,
  CONTAINERINFO_BY_INSTANCEID_REQ
} from '@/store/modules/agents/agents.type'

export default {
  data () {
    return {
      loadingContainerDetails: false
    }
  },
  methods: {
    gotoHostDetails () {
      this.$router.push({
        name: 'host-insights',
        params: { agentId: this.details.agentId }
      })
    },
    getContainerInfo () {
      this.$store.dispatch(AGENT_CONTAINER_INFO_REQ, this.details.agentId).then(containerInfo => {
        this.details.setContainerInfo(containerInfo)
      })
    },
    loadContainerDetailsByAgentId () {
      this.loadingContainerDetails = true
      this.$store.dispatch(CONTAINERINFO_BY_AGENTID_REQ, this.details.agentId).then(
        container => {
          this.loadingContainerDetails = false
          this.details.containerDetails = container
        },
        errMsg => {}
      )
    },
    loadContainerDetailsByInstanceId () {
      this.loadingContainerDetails = true
      this.$store.dispatch(CONTAINERINFO_BY_INSTANCEID_REQ, this.instanceId).then(
        container => {
          this.loadingContainerDetails = false
          this.details.containerDetails = container
        },
        errMsg => {}
      )
    }
  },
  computed: {
    ...mapGetters([]),
    instanceId () {
      if (this.details.agentDetails.instanceId) {
        return this.details.agentDetails.instanceId
      }
      let ec2 = this.details.agentDetails.system.ec2Instance
      if (ec2) {
        if (ec2.instanceId) {
          return ec2.instanceId
        }
      }
      return ''
    },
    containerDetails () {
      if (this.details.containerDetails) {
        return this.details.containerDetails
      }
      return false
    },
    clusterCount () {
      if (this.details.containerDetails) {
        return _.filter(this.details.containerDetails, 'k8sClusterKey').length
      }
      return 0
    },
    podCount () {
      if (this.details.containerDetails) {
        return _.filter(this.details.containerDetails, 'podName').length
      }
      return 0
    },
    vmRegion () {
      if (this.details.agentDetails.region) {
        return this.details.agentDetails.region
      }
      let ec2 = this.details.agentDetails.system.ec2Instance
      if (ec2) {
        if (ec2.availabilityZone) {
          let availZone = ec2.availabilityZone
          return availZone.substring(0, availZone.length - 1)
        }
      }
      return ''
    },
    securityGroups () {
      if (this.details.agentDetails.securityGroupsList) {
        return this.details.agentDetails.securityGroupsList
      }
      let ec2 = this.details.agentDetails.system.ec2Instance
      if (ec2) {
        if (ec2.securityGroups) {
          return ec2.securityGroups
        }
      }
      return ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/expand/expandedVmMixin.js